import { Key } from "@mui/icons-material";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Pincode } from "@prkhch/react-pincode";
import { formatPhone, saveMap } from "data/functions";
import React, { useRef, useState } from "react";
const { GetData } = require("contexts/DataContext");

export function CheckPin(props) {
  const { dataObj } = GetData();
  const [checkPin, setCheckPin] = React.useState("");
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (error)
      setTimeout(() => {
        setError(false);
      }, 1000);
  }, [error]);

  function handleSubmit() {
    if (checkPin === (dataObj?.pin || "")) {
      props?.setCheck(true);
    } else {
      setError(true);
    }
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        height: "100%",
        justifyContent: "center",
        padding: "0.4rem",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0px",
          height: "100%",
          justifyContent: "center",
          padding: "0.4rem",
          width: "200px",
        }}
      >
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Key />
              </InputAdornment>
            ),
            style: {
              fontSize: dataObj?.deviceWidth?.isMobile ? "0.875rem" : "1rem",
            },
          }}
          autoComplete="ViewCrunch"
          inputProps={{
            autocomplete: "off",
            form: {
              autocomplete: "off",
            },
            maxLength: 6,
          }}
          label="Пин-код"
          mb={2}
          mt={2}
          name="pin"
          onChange={(e) =>
            setCheckPin(e.target.value?.replace(/\D/g, ""), "pin")
          }
          // fullWidth
          onKeyDown={(ev) => {
            if (ev.keyCode === 13) {
              ev.preventDefault();
              handleSubmit();
            }
          }}
          placeholder="Введите пин-код..."
          sx={{ margin: "0.875rem 0" }}
          type="text"
          value={checkPin || ""}
          variant="standard"
        />
        <Button
          color={error ? "error" : "info"}
          onClick={(e) => handleSubmit()}
          variant="contained"
        >
          OK
        </Button>
      </Box>
    </Box>
  );
}

// export function CheckPin(props) {
//   const ref = useRef();
//   const { dataObj } = GetData();
//   const [pin, setPin] = React.useState(dataObj?.pin || "");

//   React.useEffect(() => {
//     setPin(dataObj?.pin || "");
//   }, [dataObj?.pin]);

//   const onComplete = ({
//     inputValue,
//     setErrorMessage,
//     setMessage,
//   }: ON_COMPLETE_PROPS) => {
//     // Request correct password from the server.
//     // Example correct password : 0000

//     if (pin === inputValue) {
//       // setMessage(String.fromCodePoint(32));
//       props?.setCheck(true);
//       setErrorMessage("");
//     } else {
//       setErrorMessage("Неверный пин-код!");
//       // ref.current.style[".inputBox.svg"].border = "1 px solid red";
//       // setErrorMessage("Не!");
//     }
//   };

//   return (
//     <Box
//       ref={ref}
//       sx={{
//         ".container": { height: "100%" },
//         ".containerBottom": { height: "100%" },
//         ".keypadBox": { width: "unset" },
//         ".keypadRow": { height: "unset" },
//         ".shake": {
//           animation: "vibration 0.05s",
//         },
//         alignContent: "center",
//         alignItems: "center",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         paddingTop: "24px",
//         width: "100%",
//       }}
//     >
//       <Typography sx={{ padding: "12px 0" }} textAlign={"center"}>
//         Введите пин-код
//       </Typography>

//       <Pincode
//         defaultMessage="&nbsp;"
//         // randomKeypad={true}
//         length={4}
//         onComplete={onComplete}
//         style={{
//           // "&containerBottom": { height: "100px!important" },
//           maxWidth: "400px",
//           width: "100%",
//         }}
//         styleBackgroundColor="transparent"
//         styleBackgroundOpacity={1}
//         // styleBottomLayout={true}
//         styleDeleteButtonColor="red"
//         styleErrorMessageColor="red"
//         styleHoverColor="#efefef"
//         styleInputBoxColor="#efefef"
//         styleInputCircleColor="#000000"
//         styleMessageColor="#000000"
//         styleNumberButtonColor="#efefef"
//         styleNumberFontColor="#000000"
//         styleResetButtonColor="blue"
//       />
//     </Box>
//   );
// }
